import React, { useEffect, useState } from 'react';
import { db } from '../firebase'; // Firebase config
import { collection, getDocs } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const TouristResortsPage = () => {
  const [resorts, setResorts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    country: '',
    city: '',
    minPrice: '',
    maxPrice: '',
  });

  useEffect(() => {
    const fetchResorts = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'touristResorts'));
        const resortsList = [];
        querySnapshot.forEach((doc) => {
          resortsList.push({ id: doc.id, ...doc.data() });
        });
        setResorts(resortsList);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching resorts:', err);
        setLoading(false);
      }
    };

    fetchResorts();
  }, []);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  const filteredResorts = resorts.filter((resort) => {
    const { country, city, minPrice, maxPrice } = filters;
    const price = resort.price || 0;
    return (
      (country ? resort.country.toLowerCase().includes(country.toLowerCase()) : true) &&
      (city ? resort.city.toLowerCase().includes(city.toLowerCase()) : true) &&
      (minPrice ? price >= minPrice : true) &&
      (maxPrice ? price <= maxPrice : true)
    );
  });

  if (loading) {
    return <div className="text-center mt-20 text-xl">جاري تحميل المنتجعات السياحية...</div>;
  }

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-4xl font-bold text-green-600">المنتجعات السياحية</h1>
      </div>

      {/* Filter Form */}
      <div className="mb-6">
        <h2 className="text-xl font-semibold mb-4">تصفية المنتجعات</h2>
        <form className="space-y-4">
          <input
            type="text"
            name="country"
            placeholder="الدولة"
            value={filters.country}
            onChange={handleFilterChange}
            className="p-3 border border-gray-300 rounded-lg w-full"
          />
          <input
            type="text"
            name="city"
            placeholder="المدينة"
            value={filters.city}
            onChange={handleFilterChange}
            className="p-3 border border-gray-300 rounded-lg w-full"
          />
          <div className="flex space-x-4">
            <input
              type="number"
              name="minPrice"
              placeholder="أدنى سعر"
              value={filters.minPrice}
              onChange={handleFilterChange}
              className="p-3 border border-gray-300 rounded-lg w-full"
            />
            <input
              type="number"
              name="maxPrice"
              placeholder="أقصى سعر"
              value={filters.maxPrice}
              onChange={handleFilterChange}
              className="p-3 border border-gray-300 rounded-lg w-full"
            />
          </div>
        </form>
      </div>

      {/* Resorts Display */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredResorts.map((resort) => (
          <div key={resort.id} className="bg-white p-6 rounded-lg shadow-lg">
            {/* Resort Picture */}
            {resort.picture ? (
              <img
                src={resort.picture}
                alt={`${resort.name} صورة`}
                className="w-full h-48 object-cover rounded-lg mb-4"
              />
            ) : (
              <div className="w-full h-48 bg-gray-300 rounded-lg mb-4 flex items-center justify-center text-gray-600">
                لا توجد صورة
              </div>
            )}

            {/* Resort Name */}
            <h2 className="text-xl font-semibold text-gray-800">{resort.name}</h2>

            {/* Resort Description */}
            <p className="text-gray-600 text-center mt-2">{resort.description}</p>

            {/* Resort Price */}
            <p className="text-gray-800 text-center mt-4 font-semibold">
              السعر: دج{resort.price}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TouristResortsPage;
